import { Component, forwardRef, ViewEncapsulation, Input, TemplateRef } from '@angular/core';
import { NexusComponent } from '../nexus/nexus.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormControl } from '@angular/forms';
import { fullscreenIcon } from '@progress/kendo-svg-icons';
import { ActionsLayout } from '@progress/kendo-angular-dialog';
@Component({
  standalone: false,
  selector: 'nexus-editor',
  templateUrl: './nexus-editor.component.html',
  styleUrls: ['./nexus-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => NexusEditorComponent),
    }
  ]
})
export class NexusEditorComponent extends NexusComponent implements ControlValueAccessor {
  @Input() public formControlName: string;
  @Input() public resizable: boolean = true;
  @Input() public editor_style: string = "height: 100%";
  @Input() public config_height: any = '400px';
   @Input() public modal_mode: boolean = true;
     public dialog_opened: boolean = false;
   public actions_layout: ActionsLayout = "start";
  public is_disabled: boolean = false;
  public loaded: boolean = false;
  public control: UntypedFormControl = new UntypedFormControl();
  fullscreenIcon =fullscreenIcon;
  private load = () => {
    this.loaded = true;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    setTimeout(this.load, 250); //super hacky but required to fix bug https://github.com/tinymce/tinymce-angular/issues/76

    this.control.valueChanges.subscribe((data: any) => {
      this.propagateChange(data);
    });
  }

  private propagateChange = (value: any) => { };

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {
    this.is_disabled = isDisabled;
  }
  open_dialog(template: TemplateRef<unknown>){
    this.dialog_opened =true;
  }

  close_dialog(){
    if(this.control){
      this.control.setValue(this.control.value);
    }

    this.dialog_opened =false;
  }

}
